import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setMasterpassVersion } from 'Stores/CreditCardTransactions';
import { toMasterpassVersion } from 'Utils/Masterpass';

/**
 * Mobil WebView akışlarında Masterpass sürümünü store'a yazar.
 *
 * ─── NEDEN GEREKLİ ────────────────────────────────────────────────────────────
 * Web akışında sürüm, token servisinin cevabındaki `IsVersion2Active`'ten gelir.
 * Mobil ise token'ı native uygulamadan HAZIR alır ve token servisini hiç çağırmaz
 * — yani o cevabı hiç görmez. Native bayrağı WebView adresinde iletiyor; bu hook
 * onu okuyup store'a yazıyor.
 *
 * ⚠️ SAYFA AÇILIŞINDA BİR KEZ ÇAĞRILMALI. `onGetMasterpassForMobileRequest` sekiz
 * dosyada on altı ayrı yerden dispatch ediliyor ve bir kısmı OTP / tekrar gönderim
 * gibi akışın ORTASINDAKİ adımlar. Bayrağı her dispatch'e tek tek geçirmek, on altı
 * noktanın hepsini doğru yapmaya bağlı olurdu; biri unutulduğunda akış ortasında
 * sürüm değişir ve doğrulama adımı hiç görmediği bir SDK'ya gider.
 *
 * ⚠️ Bayrak gelmezse HİÇBİR ŞEY YAZILMAZ ve saga'nın varsayılanı (`v1`) geçerli
 * olur. Bu kasıtlı: sahada kalan eski uygulama sürümleri bayrağı göndermiyor ve
 * onların v1'de kalması gerekiyor.
 *
 * @param flag Native'in ilettiği ham değer — `"true"` / `"false"` / boolean / null.
 */
export const useMobileMasterpassVersion = (flag?: string | boolean | null) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (flag === undefined || flag === null || flag === '') {
      return;
    }

    dispatch(setMasterpassVersion(toMasterpassVersion(flag)));
  }, [dispatch, flag]);
};

export default useMobileMasterpassVersion;
